export default {
  h:       [true, true, true, true, true, true, true, true],
  e:       [true, true, true, true, true, true, true, true],
  c:       [true, true, true, true, true, true, true, true, true, true],
  cotiCol: [true, true, true, true, true, true, true, true, true, true, true, true],
  cotiInd: [true, true, true, true, true, true, true, true, true],
  presta:  [true, true, true, true, true, true, true]
}
